import classNames from "classnames";
import "./index.scss";
import AlertCloseModal from "../AlertCloseModal";
import { useState } from "react";
type Props = {
  open: boolean;
  label?: string | null;
  width?: number | string;
  footer?: React.ReactNode;
  height?: number | string;
  margin?: number | string;
  onClose: () => void;
  children: React.ReactNode;
  minWidth?: number | string;
  maxWidth?: number | string;
  minHeight?: number | string;
  maxHeight?: number | string;
  overlayClose?: boolean;
  setShowModal?: (event: string) => void;
  closeAlert?: boolean;
  overlayOpacity?: string;
};

const CustomModal = ({
  open,
  label,
  width,
  footer,
  height,
  margin,
  onClose,
  children,
  minWidth,
  maxWidth,
  minHeight,
  maxHeight,
  overlayClose,
  setShowModal,
  closeAlert = false,
  overlayOpacity,
}: Props) => {
  const [showCloseAlert, setShowCloseAlert] = useState<boolean>(false);

  const onCloseHandler = () => {
    if (closeAlert) {
      setShowCloseAlert(true);
    } else {
      onClose();
    }
  };
  if (!open) return null;
  return (
    <>
      <section
        onClick={overlayClose ? onClose : () => false}
        id="overly-custom-modal-container"
        style={
          overlayOpacity
            ? {
                backgroundColor: `rgba(0,0,0, ${overlayOpacity})`,
              }
            : {}
        }
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          className={classNames(
            { "scale-up-ver-center": open },
            "modal-container"
          )}
          style={{
            width: width,
            minWidth: minWidth,
            maxWidth: maxWidth,
            height: height,
            minHeight: minHeight,
            maxHeight: maxHeight,
            margin: margin,
          }}
        >
          <div className="modal-header">
            {label && <span className="modal-title">{label}</span>}
            <i
              className="fa-solid fa-xmark closeBtn "
              onClick={onCloseHandler}
            ></i>
          </div>
          <div className="modal-body">{children}</div>
          {footer && <div className=" modal-footer">{footer}</div>}
        </div>
      </section>
      <AlertCloseModal
        setShowAlert={setShowCloseAlert}
        showAlert={showCloseAlert}
        setShowModal={() => setShowModal!("NONE")}
      />
    </>
  );
};

export default CustomModal;
